import { FC } from 'react';

import { SvgIconProps } from 'types/styles';
import { SvgIcon } from 'ui/SvgIcon';

export const VisibilityOffIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M11.9997 19.5C12.9457 19.5 13.8097 19.397 14.5977 19.219L12.8407 17.462C12.5677 17.483 12.2907 17.5 11.9997 17.5C6.64874 17.5 4.57573 13.654 4.07373 12.5C4.45068 11.6588 4.95978 10.8833 5.58173 10.203L4.18373 8.80497C2.64573 10.472 2.06273 12.151 2.05173 12.184C1.98276 12.3893 1.98276 12.6116 2.05173 12.817C2.07273 12.883 4.36673 19.5 11.9997 19.5ZM11.9997 5.49997C10.1627 5.49997 8.65373 5.89597 7.39573 6.48097L3.70673 2.79297L2.29273 4.20697L20.2927 22.207L21.7067 20.793L18.3877 17.474C21.0017 15.523 21.9347 12.859 21.9487 12.817C22.0177 12.6116 22.0177 12.3893 21.9487 12.184C21.9267 12.117 19.6327 5.49997 11.9997 5.49997ZM16.9717 16.058L14.6917 13.778C14.8817 13.388 14.9997 12.959 14.9997 12.5C14.9997 10.859 13.6407 9.49997 11.9997 9.49997C11.5407 9.49997 11.1117 9.61797 10.7227 9.80897L8.91473 8.00097C9.90725 7.66038 10.9504 7.49097 11.9997 7.49997C17.3507 7.49997 19.4237 11.346 19.9257 12.5C19.6237 13.192 18.7597 14.842 16.9717 16.058Z"
      fill="currentColor"
    />
  </SvgIcon>
);
